import { getFromLocalStorage, setToLocalStorage } from '../../common/dom-helpers'
import { LocalStorageKeys } from '../../environments'
import { getInternalFeatureFlag } from '../feature-flags'
import { LaunchDarklyVariations } from '../feature-flags/models'
import type { Theme } from '../shell-namespace'
import { emitThemeChanged } from '../shell-namespace'

export const DEFAULT_THEME: Theme = 'light'

export function setChameleonTheme(theme: Theme) {
  const currentTheme = getChameleonTheme()
  if (currentTheme !== theme) {
    setChameleonThemeInLocalStorage(theme)
    emitThemeChanged(theme)
  }
}

export function updateChameleonThemeProvider(themeProvider: Element, theme: Theme) {
  if (theme === 'system') {
    themeProvider.setAttribute('automatic', 'true')
    // The following line is a temporary fix while the Chameleon team works on a fix for the following bug:
    // https://jira.ops.expertcity.com/browse/CHAMELEON-2190
    themeProvider.setAttribute('theme', DEFAULT_THEME)
  } else {
    themeProvider.setAttribute('automatic', 'false')
    themeProvider.setAttribute('theme', theme)
  }
}

export function setChameleonThemeInLocalStorage(theme: Theme) {
  setToLocalStorage(LocalStorageKeys.chameleonTheme, theme)
}

export function getChameleonTheme(): Theme {
  let theme = getInternalFeatureFlag(LaunchDarklyVariations.SHELL_ENABLE_DARKMODE)
    ? (getFromLocalStorage(LocalStorageKeys.chameleonTheme) as Theme | null)
    : DEFAULT_THEME

  if (!theme) {
    theme = DEFAULT_THEME
  }
  return theme
}
